import { render, staticRenderFns } from "./email-distributions.vue?vue&type=template&id=a98b369e"
import script from "./email-distributions.vue?vue&type=script&lang=js"
export * from "./email-distributions.vue?vue&type=script&lang=js"
import style0 from "./email-distributions.vue?vue&type=style&index=0&id=a98b369e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports